import * as React from "react"
import PropTypes from "prop-types"

function IconFileUpload({ file }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29" fill="none" viewBox="0 0 25 29">
      <path
        fill={file ? "#2ED47A" : "#F7A941"}
        d="M22.252 28.204h-15a2.002 2.002 0 01-2-2v-6h2v6h15v-22h-9v-2h9a2.002 2.002 0 012 2v22a2.002 2.002 0 01-2 2z"
      ></path>
      <path
        fill={file ? "#2ED47A" : "#F7A941"}
        d="M13.252 8.204h7v2h-7v-2zm-1 5h8v2h-8v-2zm-1 5h9v2h-9v-2zm-6-1a5.005 5.005 0 01-5-5v-11h2v11a3 3 0 106 0v-9a1 1 0 10-2 0v10h-2v-10a3 3 0 116 0v9a5.005 5.005 0 01-5 5z"
      ></path>
    </svg>
  )
}

IconFileUpload.propTypes = {
  file: PropTypes.string,
}

export default IconFileUpload
